import { useMutation } from '@tanstack/react-query';
import { apiClinicOnboardingRegisterOrganisation } from 'lib/api/firebase/apis/apis';

interface OrganisationRegistrationMutationProps {
  onSuccessCallback?: () => void;
  onErrorCallback?: (error: Error) => void;
}

export function useOrganisationRegistrationMutation(props: OrganisationRegistrationMutationProps) {
  return useMutation({
    mutationFn: apiClinicOnboardingRegisterOrganisation,
    onSuccess: () => {
      props.onSuccessCallback?.();
    },
    onError: (error) => {
      props.onErrorCallback?.(error as Error);
    },
  });
}
